import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/library/card";
import PrefrenceFormRenderer from "@/components/ui/others/PrefrenceRenderers/PrefrenceFormRenderer";
import { useEducation } from "../../context/EducationContext";
import { child_spesific_key } from "@/config/endpoints";
import { useMemo } from "react";
import { getCourseCountries } from "@/features/universityAndCourse/hooks/useCourseFilters";
import {
  useApplicationPrefMarks,
  useRequiredApplicationPrefs,
} from "../requiredApplicationPrefs";
import { RequiredFieldMarksContext } from "@/features/leads/requirements/requiredFieldMarks";

export default function ChildPrefrenceCard() {
  const { moduleScopes, course } = useEducation();
  // Country follows the course → university; locks the deal's Country field.
  const courseCountries = useMemo(() => getCourseCountries(course), [course]);
  const requiredPrefs = useRequiredApplicationPrefs();
  const marks = useApplicationPrefMarks(requiredPrefs);

  return (
    <Card className="border-[#e6e8e7] rounded-[16px] gap-1 py-4 shadow-none">
      <CardHeader className="px-4 pb-0">
        <CardTitle className="text-[16px] font-medium text-black tracking-[-0.32px] leading-normal">
          Prefrences{" "}
          {requiredPrefs.length === 0 && (
            <span className="font-normal text-slate-500">(optional)</span>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 pt-0">
        <div className="pl-2 w-full">
          <RequiredFieldMarksContext.Provider value={marks}>
            <PrefrenceFormRenderer
              hook={useEducation}
              modelName="child"
              queryKey={child_spesific_key}
              moduleScopes={moduleScopes}
              countryValues={courseCountries}
              fullWidth
            />
          </RequiredFieldMarksContext.Provider>
        </div>
      </CardContent>
    </Card>
  );
}
